enum Topics {
    LOGIN='ahg.login',
    REGISTER='ahg.register',
    REGISTERED='ahg.registered',
    RESET_PASSWORD='ahg.resetPassword',
    START_LOADER='ahg.startloader',
    STOP_LOADER='ahg.stoploader',
}

export default Topics